import client from '@/http'

const loadAll = (context) => {
  client.get(
    'types'
  ).then(
    (res) => {
      context.commit('SET_TYPES', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

export default {
  loadAll
}
